<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :tree-config="treeConfig"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 42"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.optionStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.optionStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  params: row
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  params: row
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.optionCode)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      type: Object,
      default: () => {}
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'optionName',
          headerAlign: 'left',
          align: 'left',
          minWidth: 150,
          title: this.$l('table_label_alternative_name') || '备选项名称',
          showHeaderOverflow: 'title',
        },
        {
          field: 'optionNameEn',
          headerAlign: 'left',
          align: 'left',
          minWidth: 200,
          title: this.$l('form_label_alternative_english_name') || '备选项英文名称',
          showHeaderOverflow: 'title',
        },
        // {
        //   field: 'metadataType',
        //   headerAlign: 'center',
        //   align: 'left',
        //   minWidth: 150,
        //   title: this.$l('table_label_alternative_type') || '属性类型',
        //   showHeaderOverflow: 'title',
        // }
      ]
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('btn_this_want_delete') || '确认要删除该记录吗？',
        this.$l('btn_this_confirmation_information') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$api.materialOptionsDelApi({ optionCode: code }).then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success'
            })
            this.$emit('reload')
          })
        })
        .catch(() => {})
    }
  }
}
</script>
